module.exports = __webpack_public_path__ + "static/media/covera-2-cropped.9391d85d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/covera-2-cropped.jpg
// module id = 47
// module chunks = 0